"use strict";

exports.__esModule = true;
exports.default = isNaN;
var _setup = require("./_setup.js");
var _isNumber = _interopRequireDefault(require("./isNumber.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Is the given value `NaN`?
function isNaN(obj) {
  return (0, _isNumber.default)(obj) && (0, _setup._isNaN)(obj);
}